  <template>
  <div class='kz-cont' v-show='showstate'>
    <div class='kz-wrapper' >
      <div class='kz-text'>
        <strong><slot name='tlt' ></slot></strong>
        <span><slot name='text' ></slot></span>
      </div>
      <div class='kz-cont_footer'>
        <div @click='tocancel' class='kz-btn'>取消</div>
        <div class='kz-btn' @click='took'>确定</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'eject',
    props:['type','showstate'],
    methods:{
      tocancel:function(){
        this.$emit('tocancel');
      },
      took:function(){
        this.$emit('took');
      }
    }
  }
</script>
<style>
  .kz-cont{position:fixed;left:0;right: 0;top:0;bottom: 0;z-index: 5000;background:rgba(0,0,0,0.3);text-align:center;overflow: hidden;white-space:nowrap;}
  .kz-cont:after{content:"";display:inline-block;width:0;height:100%;visibility: hidden;vertical-align:middle;}
  .kz-wrapper{display:inline-block;vertical-align:middle;background:#fff;border-radius: 0.15rem;  width: calc(100% - 130px);}
  .kz-text{text-align:center; padding:20px 0 40px; font-size: 28px;}
  .kz-text span{ display: block; margin-top: 20px; color: #898a8c;}
  .kz-text strong span { font-size: 33px; color:#000000;}
  .kz-cont_footer{display:flex;border-top:1px solid #E5E5E5;color:#488BF1;}
  .kz-btn{flex:1;padding: 30px 20px; font-size: 32px; color: #000;}
  .kz-btn +.kz-btn{border-left:1px solid #E5E5E5; font-size: 32px; color: #e91919}
</style>



// WEBPACK FOOTER //
// src/components/Bounced.vue